"use client";

import { ArrowForwardIcon } from "@chakra-ui/icons";
import { Link } from "@chakra-ui/next-js";
import { Button } from "@chakra-ui/react";

const ReadMoreLink = ({ href }: { href: string }) => {
  return (
    <Button
      as={Link}
      href={href}
      variant="link"
      rightIcon={<ArrowForwardIcon />}
      color="#071920"
      fontSize="14px"
      fontWeight="700"
      cursor="pointer"
      _hover={{
        textDecoration: "none",
      }}
    >
      Read More
    </Button>
  );
};

export default ReadMoreLink;
